import React from 'react';
import PropTypes from 'prop-types';

import { Trans } from 'react-i18next';
import LiteralCurrency from 'components/LiteralCurrency';

const DiffPriceWhenEdit = ({
  className,
  originalTotalPrice,
  diff,
  hasToShowDiffPriceWhenEdit,
  label,
  t,
}) => (
  <div className={`${className} diff-price`}>
    {hasToShowDiffPriceWhenEdit && (
      <p>
        <Trans
          t={t}
          i18nKey={label}
          values={{ total: originalTotalPrice, diff }}
          components={[
            <LiteralCurrency value={originalTotalPrice} />,
            <LiteralCurrency value={diff && Math.abs(diff)} />,
          ]}
        />
      </p>
    )}
  </div>
);

DiffPriceWhenEdit.propTypes = {
  className: PropTypes.string.isRequired,
  originalTotalPrice: PropTypes.number,
  diff: PropTypes.number,
  label: PropTypes.string,
  hasToShowDiffPriceWhenEdit: PropTypes.bool,
};

DiffPriceWhenEdit.defaultProps = {
  originalTotalPrice: 0,
  diff: 0,
  label: '',
  hasToShowDiffPriceWhenEdit: false,
};

export default DiffPriceWhenEdit;
